import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { HttpParams } from '@angular/common/http';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { SolicitudDeclaracionSuplementariaExViewModel } from './declsuplemetaria.types';
import { DeclaracionSuplementariaService } from './declsuplemetaria.service';
import { EnumIdsTwTcTipoClonacion, EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { DeclaracionAdicionalPopupComponent } from '../components/popup/declaracionadicional/declaracionadicionalPopup.component';
import {
    DeclaracionSuplementariaItemResultsViewModel,
    TDeclaracionSuplementariaViewModel,
} from '../../../_mantenimiento/general/declaracionessuplementarias/declaracionsuplementaria.types';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';

@Component({
    selector: 'app-declsuplementariaex',
    templateUrl: './declsuplemetaria.component.html',
})
export class DeclSuplementariaExComponent extends ComponentBase implements OnInit {
    @ViewChild(DeclaracionAdicionalPopupComponent)
    private declaracionAdicionalPopupComponent: DeclaracionAdicionalPopupComponent;

    solicitudDeclaracionSuplementariaEx: SolicitudDeclaracionSuplementariaExViewModel;
    habilitarGuardar = true;
    habilitarEdicion = true;
    visibilitySpinner = false;
    tituloTipoSolicitud: string;
    laHeGrabadoYo = false;
    esClonada = false;
    IdTipoSolicitudEx: number;
    idSolicitudEx: number;

    declaracionSupl: string;
    declaracionSuplInspector: string;
    esSolicitudCampanias = false;
    readonlyDeclaracion = false;
    numDeclaracionesAdicionales: number;
    declaracionesAdicionales: DeclaracionSuplementariaItemResultsViewModel;
    descripcionCampania: string;
    visibilityBuscadorDeclaracion = false;
    declCeNoGuardada = false;
    noHayDeclActivas = false;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private declSuplExService: DeclaracionSuplementariaService,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudDeclaracionSuplementariaEx = new SolicitudDeclaracionSuplementariaExViewModel();
    }

    ngOnInit() {
        this.declCeNoGuardada = false;
        this.idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitudEx);

        this.createForm();

        //Siempre tendrá un id
        if (this.idSolicitudEx) {
            this.loading = true;

            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitudEx', this.idSolicitudEx.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());
            this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                //recuperar la solicitud
                this.declSuplExService.getSolicitudDeclaracionSuplementariaEx(this.idSolicitudEx).subscribe(result => {
                    this.solicitudDeclaracionSuplementariaEx = result;

                    this.IdTipoSolicitudEx = this.solicitudDeclaracionSuplementariaEx.IdTipoSolicitudEx;
                    this.tituloTipoSolicitud = this.solicitudDeclaracionSuplementariaEx.IdTipoSolicitudExDescripcion;
                    this.esClonada =
                        this.solicitudDeclaracionSuplementariaEx.TwSolicitudJerarquiaEx != null &&
                        this.solicitudDeclaracionSuplementariaEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.esSolicitudCampanias = this.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS ? true : false;

                    //SI ES PREVIA
                    if (this.solicitudDeclaracionSuplementariaEx.EsPrevia) {
                        if (
                            this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += '-Previa';
                        }
                    }
                    //SI ES SOLICITUD CAMPAÑAS
                    if (this.esSolicitudCampanias) {
                        this.declSuplExService.getDeclaracionesByIdCampania(this.solicitudDeclaracionSuplementariaEx.IdCampania!).subscribe(resultDecl => {
                            this.numDeclaracionesAdicionales = resultDecl.ResultList.length;
                            this.visibilityBuscadorDeclaracion = this.numDeclaracionesAdicionales > 1 ? true : false;
                            this.declaracionesAdicionales = resultDecl;
                            this.descripcionCampania = this.solicitudDeclaracionSuplementariaEx.CampaniaDescripcion;
                            //SI sólo hay una Declaración se carga
                            if (this.numDeclaracionesAdicionales == 1) {
                                this.readonlyDeclaracion = true;
                                this.form.setValue({
                                    DeclaracionSuplementaria:
                                        this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria != null
                                            ? this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria
                                            : resultDecl.ResultList[0].TextoDecSuplementaria,
                                    DeclaracionSuplementariaInspector: this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementariaInspector,
                                });
                                this.declaracionSupl =
                                    this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria != null
                                        ? this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria
                                        : resultDecl.ResultList[0].TextoDecSuplementaria;
                                //Si no está guardada muestro mensaje info
                                if (this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria == null) {
                                    this.declCeNoGuardada = true;
                                }
                            } else {
                                this.updateForm();
                                this.readonlyDeclaracion = this.numDeclaracionesAdicionales > 1 ? true : false;
                                if (!this.readonlyDeclaracion) {
                                    this.noHayDeclActivas = true;
                                }
                            }
                        });
                    } else {
                        this.updateForm();
                    }

                    this.loading = false;

                    //Todo:agaro. 16032022 .Fallaba la edición para inspector y hay que diferenciar mejor grabador-inspector, solo inspector y solicitante

                    //1 - Miramos primero las variables y luego en qué perfiles
                    this.habilitarGuardar = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.GUARDAR_DECL_SUPL,
                        this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx,
                    ).Visible;
                    this.habilitarEdicion = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION,
                        this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx,
                    ).Editable;

                    //2 - Si se habilita edición, vemos en qué perfiles
                    if (this.habilitarEdicion) {
                        //3 - Si es solicitante o grabador (sin inspector), se deshabilita la de decl. adicional de inspector y se mira que la haya grabado él mismo
                        if (
                            this.isSolicitante ||
                            (this.isGrabador && !this.isInspector)
                        ) {
                            this.form.controls['DeclaracionSuplementariaInspector'].disable();

                            if (this.isGrabador) {
                                this.habilitarGuardar =
                                    this.loggedInUser!.getAction(
                                        EnumCodigosTwTcAcciones.GUARDAR_DECL_SUPL,
                                        this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx,
                                    ).Visible && this.laHeGrabadoYo;
                                this.habilitarEdicion =
                                    this.loggedInUser!.getAction(
                                        EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION,
                                        this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx,
                                    ).Editable && this.laHeGrabadoYo;
                            }

                            //Que se cumpla todo y que la haya grabado él mismo
                        } else if (
                            this.isGrabador &&
                            this.isInspector
                        ) {
                            //Si es grabador e inspector, vemos cuál hay que deshabilitar porque no se sabe apriori, hay que mirar el estado de Solicitud

                            if (
                                this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_BORRADOR ||
                                this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE
                            ) {
                                //Si es borrador o revision solicitante, actúa como grabador
                                this.form.controls['DeclaracionSuplementariaInspector'].disable();
                                this.habilitarGuardar =
                                    this.loggedInUser!.getAction(
                                        EnumCodigosTwTcAcciones.GUARDAR_DECL_SUPL,
                                        this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx,
                                    ).Visible && this.laHeGrabadoYo;
                                this.habilitarEdicion =
                                    this.loggedInUser!.getAction(
                                        EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION,
                                        this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx,
                                    ).Editable && this.laHeGrabadoYo;
                            } else {
                                //Actúa como inspector
                                this.form.controls['DeclaracionSuplementaria'].disable();
                            }
                        } else if (this.isInspector) {
                            //Si es solo inspector solo se deshabilita la de Solicitante y ya está
                            this.form.controls['DeclaracionSuplementaria'].disable();
                        } else {
                            //No debería llegar a este else
                        }

                        //Si llega ahora deshabilitada la edición deshabilitamos los controles
                        if (!this.habilitarEdicion) {
                            this.DisableControlsConsulta();
                        }
                    } else {
                        this.DisableControlsConsulta();
                    }

                    ////Si soy Inspector-Grabador
                    //if (this.isGrabador && this.isInspector) {
                    ////    this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DECL_SUPL, this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx).Visible && this.laHeGrabadoYo;
                    ////    this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION, this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx).Editable;// && this.laHeGrabadoYo;
                    ////}
                    ////else {

                    ////this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_EXPORTACION, this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx).Visible;
                    //this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DECL_SUPL, this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx).Visible;
                    //this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DECLSUPLEMENTARIA_EXPORTACION, this.solicitudDeclaracionSuplementariaEx.IdEstadoSolicitudEx).Editable;
                    //    alert(this.habilitarEdicion);
                    //}

                    //if (!this.habilitarEdicion) {
                    //    //metodo para deshabilitar los controles
                    //    this.DisableControlsConsulta();
                    //}

                    ////Si es Solicitante o Grabador (excepto si soy Inspector-grabador y la he grabado yo), deshabilito la de Inspector
                    //if (!(this.isInspector && this.isGrabador && this.laHeGrabadoYo) &&
                    //    (this.isSolicitante || this.isGrabador) && this.habilitarEdicion) {
                    //    this.form.controls['DeclaracionSuplementariaInspector'].disable();
                    //    alert('Aquí llega y se deshabilita la de Inspector');
                    //}

                    ////Si es Inspector (excepto si soy Inspector-grabador y la he grabado yo), deshabilito la de Solicitante
                    //if (!(this.isInspector && this.isGrabador && this.laHeGrabadoYo) &&
                    //    this.isInspector && this.habilitarEdicion) {
                    //    this.form.controls['DeclaracionSuplementaria'].disable();
                    //    alert('Aquí llega y se deshabilita la de Solicitante');
                    //}
                });
            });
        }
    }

    private DisableControlsConsulta() {
        this.form.controls['DeclaracionSuplementaria'].disable();
        this.form.controls['DeclaracionSuplementariaInspector'].disable();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            DeclaracionSuplementaria: '',
            DeclaracionSuplementariaInspector: '',
        });
    }

    updateForm() {
        this.form.setValue({
            DeclaracionSuplementaria: this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria,
            DeclaracionSuplementariaInspector: this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementariaInspector,
        });

        this.declaracionSupl = this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria;
        this.declaracionSuplInspector = this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementariaInspector;
    }

    onBack() {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.solicitudDeclaracionSuplementariaEx.Id]);
    }

    onSearchDeclaracionSuplementaria(): void {
        this.declaracionAdicionalPopupComponent.showDialog(this.declaracionesAdicionales, this.descripcionCampania);
    }

    onAcceptDialogDeclaracionAdicional(declaracionAdicional: TDeclaracionSuplementariaViewModel): void {
        this.form.patchValue({
            DeclaracionSuplementaria: declaracionAdicional.TextoDecSuplementaria,
        });
        this.declaracionSupl = declaracionAdicional.TextoDecSuplementaria;
        if (this.solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria != this.declaracionSupl) {
            this.declCeNoGuardada = true;
        } else {
            this.declCeNoGuardada = false;
        }
    }

    guardarDeclaracionSuplementaria() {
        //this.confirmationService.confirm({
        //    message: '¿Está seguro de guardar la Declaración Suplementaria de la solicitud?',
        //    accept: () => {
        //        this.onSubmit();
        //    }
        //});

        this.onSubmit();
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        const solicitudDeclaracionSuplementariaEx = new SolicitudDeclaracionSuplementariaExViewModel();

        solicitudDeclaracionSuplementariaEx.Id = this.solicitudDeclaracionSuplementariaEx.Id;

        //Todo:agaro. 11/11/2020. Tenemos que revisar si está disabled el campo, que coja el valor almacenado.
        //DECL
        let decSupl = this.form.value.DeclaracionSuplementaria;
        if (this.form.controls['DeclaracionSuplementaria'].disabled) {
            decSupl = this.declaracionSupl; //Valor almacenado
        }

        //DECL. Inspector
        let decSuplInspector = this.form.value.DeclaracionSuplementariaInspector;
        if (this.form.controls['DeclaracionSuplementariaInspector'].disabled) {
            decSuplInspector = this.declaracionSuplInspector; //Valor almacenado
        }

        solicitudDeclaracionSuplementariaEx.DeclaracionSuplementaria = decSupl; //this.form.value.DeclaracionSuplementaria;
        solicitudDeclaracionSuplementariaEx.DeclaracionSuplementariaInspector = decSuplInspector; //this.form.value.DeclaracionSuplementariaInspector;

        this.declSuplExService.editSolicitudDeclaracionSuplementariaEx(solicitudDeclaracionSuplementariaEx).subscribe({
            next: () => {
                this.addSuccessMessage('Declaración adicional guardada correctamente');
                //this.onBack();
                if (this.esSolicitudCampanias) {
                    this.ngOnInit();
                }
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }
}
